module.exports = __webpack_public_path__ + "site/img/65.1305643d.jpg";